export default "__VITE_PUBLIC_ASSET__4ce99f04__"